import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/lib/session";

/**
 * `/` is a signpost, not a page: signed in goes to the dashboard, signed out
 * goes to login. Doing it in `beforeLoad` means no flash of an empty screen
 * on the way through.
 */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    throw redirect({ to: me ? "/dashboard" : "/login" });
  },
});
